import { useMemo } from "react";
import { useFirmData } from "./useFirmData";

/**
 * Rapor firma seçicilerinin ortak listesi (#223).
 *
 * - Depo firmaları hiçbir raporda seçilemez — raporlar müşteri / bayi içindir.
 * - `includeInactive: false` (Müşteri Bakiye Seviyeleri): pasif firmalar
 *   listelenmez; sunucu bu raporda yalnız aktif firmaları hesaplıyor, pasifi
 *   seçtirmek boş rapor üretiyordu. Müşteri Performans pasifleri listeler —
 *   tüketim kayıtlarından hesaplanır, FirmDropdown `inactiveToggle`.
 * - Diğer raporlarda pasifler kalır; FirmDropdown "Pasif" etiketini basar.
 *
 * @param {Array} firms
 * @param {{ includeInactive?: boolean }} [opts]
 */
export function filterReportFirms(firms, { includeInactive = true } = {}) {
  return (firms || []).filter(
    (f) => f?.firmType !== "storage" && (includeInactive || f?.isActive !== false)
  );
}

/** useFirmData + filterReportFirms */
export default function useReportFirms(token, opts = {}) {
  const { includeInactive = true } = opts;
  const { firms, ...rest } = useFirmData(token);
  const reportFirms = useMemo(
    () => filterReportFirms(firms, { includeInactive }),
    [firms, includeInactive]
  );
  return { ...rest, firms: reportFirms };
}
